import axios from "axios";
import { useQuery } from "react-query";

export const useAggrMetricsAcrossDimensions = ({
    contentType,
    activeFilters = [],
    dimensions,
    metrics,
    findQuery,
    queryOptions = {},
    vizCardId,
  }) => {

    const body = {
        contentType,
        dimensions,
        metrics,
        findQuery,
        activeFilters
    }
  
    const endpoint = `/api/insightMatrix/aggrMetricsAcrossDimensions`
  
    return useQuery({
      queryKey: ["useAggrMetricsAcrossDimensions", vizCardId, body],
      queryFn: () =>
        axios
          .post(endpoint, body, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((data) => data.data),
      ...queryOptions,
    });
  };
